import './image.scss';

import classNames from 'classnames';

interface Props extends React.HTMLAttributes<HTMLImageElement> {
	className?: string;
	lazy?: boolean;
	alt?: string;
	src: string;
	width?: string;
	height?: string;
}

export default function Image({
	className,
	lazy = true,
	width,
	height,
	alt,
	src,
	...props
}: Props): JSX.Element {
	return (
		<img
			className={classNames('image', className)}
			loading={lazy ? 'lazy' : 'eager'}
			width={width}
			height={height}
			src={src}
			alt={alt}
			{...props}
		/>
	);
}
